import {map as _map} from 'lodash';
import React, {useEffect, useState} from 'react';
import PropTypes from 'prop-types';
import {useApolloClient, useQuery} from '@apollo/client';

import {FiltersWrapper, getSelectedValues} from '@appComponents/HOCFiltersWrapper';
import {SearchFilter} from '@utils/commonFilters/SearchFilter';
import {SportsFilter} from '@utils/commonFilters/SportsFilter';
import {TournamentCategoriesFilter} from '@utils/commonFilters/TournamentCategoriesFilter';
import {GetSportsForDropdown,GetTournamentCategoryDropdownDataFromSports} from '@graphql/sport/query';
import {convertToInt} from '@utils/helpers';
import {sortDropdownOptionsAlphanumerically} from '@utils/sorters';

export const FILTER_KEY = 'spiideoCompetitorMappings';

export const DEFAULT_FILTER_VALUES = {
    search: null,
    sports: [],
    tournamentCategories: [],
};

export const SpiideoCompetitorMappingsFilters = ({
    restoreFilterValues,
    form: {changeValue: setFormFieldValue},
    filters,
    loading: isDataLoading,
}) => {
    const apollo = useApolloClient(),
        [sportOptions, setSportOptions] = useState([]),
        [selectedSports, setSelectedSports] = useState(
            restoreFilterValues(filters[FILTER_KEY], 'sports', [])
        ),
        [tournamentCategoryOptions, setTournamentCategoryOptions] = useState([]),
        [selectedTournamentCategories, setSelectedTournamentCategories] = useState(
            restoreFilterValues(filters[FILTER_KEY], 'tournamentCategories', [])
        );

    const {loading: isSportsLoading} = useQuery(GetSportsForDropdown, {
        onCompleted: (data) => {
            setSportOptions(sortDropdownOptionsAlphanumerically(data.sports.mapDataForDropdownWithIntVal()));
        },
    });

    const isLoading = isDataLoading || isSportsLoading;

    const fetchTournamentCategories = (sportIds) => {
        apollo.query({
            query: GetTournamentCategoryDropdownDataFromSports,
            variables: {sportIds},
        }).then((result) => {
            const categories = sortDropdownOptionsAlphanumerically(
                result.data.tournamentCategories.mapDataForDropdownWithIntVal()
            );
            const kept = getSelectedValues(selectedTournamentCategories, categories);
            setTournamentCategoryOptions(categories);
            setSelectedTournamentCategories(kept);
            setFormFieldValue('tournamentCategories', kept);
        });
    };

    useEffect(() => {
        if (selectedSports.length > 0) {
            fetchTournamentCategories(_map(selectedSports, (s) => convertToInt(s)));
        }
    }, []);

    const onSportChange = (event, value) => {
        if (value.length) {
            const sportIds = _map(value, (s) => convertToInt(s));
            setSelectedSports(sportIds);
            fetchTournamentCategories(sportIds);
        } else {
            setSelectedSports([]);
            setTournamentCategoryOptions([]);
            setSelectedTournamentCategories([]);
            setFormFieldValue('tournamentCategories', []);
        }
    };

    const onTournamentCategoryChange = (event, value) => {
        if (value.length) {
            setSelectedTournamentCategories(_map(value, (c) => convertToInt(c)));
        } else {
            setSelectedTournamentCategories([]);
            setFormFieldValue('tournamentCategories', []);
        }
    };

    return (
        <div className='content__filters'>
            <SearchFilter
                loading={isLoading}
                filters={filters[FILTER_KEY]}
                restoreFilterValues={restoreFilterValues}
            />
            <SportsFilter
                sports={sportOptions}
                loading={isLoading}
                filters={filters[FILTER_KEY]}
                restoreFilterValues={restoreFilterValues}
                onChangeValue={onSportChange}
            />
            <TournamentCategoriesFilter
                tournamentCategories={tournamentCategoryOptions}
                loading={isLoading}
                filters={filters[FILTER_KEY]}
                restoreFilterValues={restoreFilterValues}
                hidden={0 === selectedSports.length}
                onChangeValue={onTournamentCategoryChange}
            />
        </div>
    );
};

SpiideoCompetitorMappingsFilters.propTypes = {
    restoreFilterValues: PropTypes.func.isRequired,
    form: PropTypes.object.isRequired,
    filters: PropTypes.object.isRequired,
    loading: PropTypes.bool.isRequired,
};

export default FiltersWrapper(SpiideoCompetitorMappingsFilters, {
    name: FILTER_KEY,
    initialValues: DEFAULT_FILTER_VALUES,
});
